(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olandria-page-music"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── États YouTube IFrame API ── */
  var YT_PLAYING = 1;
  var YT_PAUSED = 2;
  var YT_ENDED = 0;

  /* ── Chargement unique de l'API YouTube, partagé entre sections ── */
  var yt = window._olandriaMusicYT || (window._olandriaMusicYT = { loading: false, ready: false, queue: [] });

  function loadYouTube(cb) {
    if (window.YT && window.YT.Player) { yt.ready = true; }
    if (yt.ready) { cb(); return; }
    yt.queue.push(cb);
    if (yt.loading) return;
    yt.loading = true;

    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      yt.ready = true;
      var q = yt.queue;
      yt.queue = [];
      q.forEach(function (fn) { fn(); });
    };

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  /* ── Formater les secondes en m:ss ── */
  function fmt(s) {
    s = Math.floor(s || 0);
    var m = Math.floor(s / 60);
    var sec = s % 60;
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  /* ── Initialiser une section ── */
  function init(root) {
    if (!root || root._mxReady) return;
    root._mxReady = true;

    var source = root.dataset.source;
    var videoId = root.dataset.videoId;
    var audioUrl = root.dataset.audioUrl;
    if (source === 'youtube' && !videoId) return;
    if (source === 'fichier' && !audioUrl) return;

    var playBtn = root.querySelector('.music-xp__play-btn');
    var visualizer = root.querySelector('.music-xp__visualizer');
    var progressArea = root.querySelector('.music-xp__progress-area');
    var progressFill = root.querySelector('.music-xp__progress-fill');
    var progressTrack = root.querySelector('.music-xp__progress-track');
    var timeEl = root.querySelector('.music-xp__time');
    var pauseBtn = root.querySelector('.music-xp__pause-btn');
    var ytWrap = root.querySelector('.music-xp__yt-wrap');

    var player = null; /* interface commune : play, pause, playing, time, duration, seek, destroy */
    var timer = null;

    function tick() {
      if (!player) return;
      var d = player.duration();
      var c = player.time();
      if (d > 0) {
        var pct = Math.min((c / d) * 100, 100);
        if (progressFill) progressFill.style.width = pct + '%';
        if (progressTrack) progressTrack.setAttribute('aria-valuenow', Math.round(pct));
        if (timeEl) timeEl.textContent = fmt(c) + ' / ' + fmt(d);
      }
    }

    function setPlaying(isPlaying) {
      if (visualizer) visualizer.classList.toggle('is-paused', !isPlaying);
      if (pauseBtn) pauseBtn.classList.toggle('is-paused', !isPlaying);
      clearInterval(timer);
      if (isPlaying) timer = setInterval(tick, 500);
      tick();
    }

    function reveal() {
      if (playBtn) { playBtn.classList.remove('is-loading'); playBtn.classList.add('is-gone'); }
      if (visualizer) visualizer.classList.add('is-visible');
      if (progressArea) progressArea.classList.add('is-visible');
      if (pauseBtn) pauseBtn.classList.add('is-ready');
    }

    /* ── Source : fichier audio (MP3 dans Contenu › Fichiers) ── */
    function startFile() {
      var audio = new Audio();
      audio.loop = true;
      audio.preload = 'auto';
      audio.src = audioUrl;

      player = {
        play: function () { var p = audio.play(); if (p && p.catch) p.catch(function () { setPlaying(false); }); },
        pause: function () { audio.pause(); },
        playing: function () { return !audio.paused; },
        time: function () { return audio.currentTime || 0; },
        duration: function () { return isFinite(audio.duration) ? audio.duration : 0; },
        seek: function (t) { audio.currentTime = t; },
        destroy: function () { audio.pause(); audio.removeAttribute('src'); audio.load(); }
      };

      audio.addEventListener('play', function () { setPlaying(true); });
      audio.addEventListener('pause', function () { setPlaying(false); });
      audio.addEventListener('loadedmetadata', tick);

      reveal();
      player.play();
    }

    /* ── Source : YouTube (lecteur caché) ── */
    function startYouTube() {
      if (playBtn) playBtn.classList.add('is-loading');
      loadYouTube(function () {
        var div = document.createElement('div');
        div.id = 'mx-yt-' + root.id;
        ytWrap.appendChild(div);

        var yp = new YT.Player(div.id, {
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            controls: 0,
            loop: 1,
            playlist: videoId,
            rel: 0,
            modestbranding: 1,
            playsinline: 1
          },
          events: {
            onReady: function (e) {
              reveal();
              e.target.playVideo();
            },
            onStateChange: function (e) {
              if (e.data === YT_PLAYING) setPlaying(true);
              else if (e.data === YT_PAUSED || e.data === YT_ENDED) setPlaying(false);
            }
          }
        });

        player = {
          play: function () { yp.playVideo(); },
          pause: function () { yp.pauseVideo(); },
          playing: function () { return typeof yp.getPlayerState === 'function' && yp.getPlayerState() === YT_PLAYING; },
          time: function () { return typeof yp.getCurrentTime === 'function' ? yp.getCurrentTime() : 0; },
          duration: function () { return typeof yp.getDuration === 'function' ? yp.getDuration() : 0; },
          seek: function (t) { yp.seekTo(t, true); },
          destroy: function () { if (typeof yp.destroy === 'function') yp.destroy(); }
        };
      });
    }

    /* Précharger l'API YouTube pour que le clic lance la musique sans délai (important sur mobile) */
    if (source === 'youtube') loadYouTube(function () {});

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (player) return;
        if (source === 'fichier') startFile();
        else startYouTube();
      });
    }

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        if (!player) return;
        if (player.playing()) player.pause();
        else player.play();
      });
    }

    if (progressTrack) {
      progressTrack.addEventListener('click', function (e) {
        if (!player) return;
        var rect = this.getBoundingClientRect();
        var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        var d = player.duration();
        if (d > 0) {
          player.seek(pct * d);
          if (progressFill) progressFill.style.width = (pct * 100) + '%';
        }
      });
    }

    /* Nettoyage (utilisé par l'éditeur de thème) */
    root._mxDestroy = function () {
      clearInterval(timer);
      if (player) player.destroy();
      player = null;
      root._mxReady = false;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.music-xp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* ── Éditeur de thème : remonter le lecteur quand un réglage change ── */
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('.music-xp');
    if (root && root._mxDestroy) root._mxDestroy();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-caoine"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── Constantes YouTube IFrame API ── */
  var YT_PLAYING = 1;
  var YT_PAUSED  = 2;
  var YT_ENDED   = 0;

  /* ── Charge l'API YouTube une seule fois ── */
  if (!window._caoineYTReady) {
    window._caoineYTReady = false;
    window._caoineQueue   = [];

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);

    var prevCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prevCallback === 'function') prevCallback();
      window._caoineYTReady = true;
      window._caoineQueue.forEach(function (fn) { fn(); });
      window._caoineQueue = [];
    };
  }

  /* ── Initialise chaque section .caoine ── */
  function initSection(root) {
    var videoId      = root.dataset.videoId;
    if (!videoId) return;

    var playBtn      = root.querySelector('.caoine__play-btn');
    var visualizer   = root.querySelector('.caoine__visualizer');
    var progressArea = root.querySelector('.caoine__progress-area');
    var progressFill = root.querySelector('.caoine__progress-fill');
    var progressTrack= root.querySelector('.caoine__progress-track');
    var timeEl       = root.querySelector('.caoine__time');
    var pauseBtn     = root.querySelector('.caoine__pause-btn');
    var ytWrap       = root.querySelector('.caoine__yt-wrap');

    var player          = null;
    var progressInterval = null;

    /* ── Formater les secondes en m:ss ── */
    function fmt(s) {
      s = Math.floor(s || 0);
      var m = Math.floor(s / 60);
      var sec = s % 60;
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    /* ── Mettre à jour la barre de progression ── */
    function startProgress() {
      clearInterval(progressInterval);
      progressInterval = setInterval(function () {
        if (!player || typeof player.getCurrentTime !== 'function') return;
        var current  = player.getCurrentTime();
        var duration = player.getDuration();
        if (duration > 0) {
          var pct = Math.min((current / duration) * 100, 100);
          if (progressFill) progressFill.style.width = pct + '%';
          if (timeEl) timeEl.textContent = fmt(current) + ' / ' + fmt(duration);
        }
      }, 500);
    }

    /* ── Basculer l'état lecture / pause ── */
    function setPlaying(isPlaying) {
      if (visualizer) {
        visualizer.classList.toggle('is-paused', !isPlaying);
      }
      if (pauseBtn) {
        pauseBtn.classList.toggle('is-paused', !isPlaying);
      }
      if (isPlaying) {
        startProgress();
      } else {
        clearInterval(progressInterval);
      }
    }

    /* ── Premier clic : créer le player YouTube ── */
    function createPlayer() {
      var divId = 'caoine-yt-' + root.id;
      var div   = document.createElement('div');
      div.id    = divId;
      ytWrap.appendChild(div);

      player = new YT.Player(divId, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          loop: 1,
          playlist: videoId,
          rel: 0,
          modestbranding: 1,
          enablejsapi: 1
        },
        events: {
          onReady: function () {
            /* Afficher le visualiseur et la progression */
            playBtn.classList.add('is-gone');
            visualizer.classList.add('is-visible');
            progressArea.classList.add('is-visible');
            pauseBtn.classList.add('is-ready');
            setPlaying(true);
          },
          onStateChange: function (e) {
            if (e.data === YT_PLAYING) setPlaying(true);
            else if (e.data === YT_PAUSED || e.data === YT_ENDED) setPlaying(false);
          }
        }
      });
    }

    /* ── Événement : bouton play initial ── */
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (window._caoineYTReady) {
          createPlayer();
        } else {
          window._caoineQueue.push(createPlayer);
        }
      });
    }

    /* ── Événement : bouton pause/reprendre ── */
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        if (!player || typeof player.getPlayerState !== 'function') return;
        var state = player.getPlayerState();
        if (state === YT_PLAYING) {
          player.pauseVideo();
        } else {
          player.playVideo();
        }
      });
    }

    /* ── Événement : clic sur la barre de progression (seek) ── */
    if (progressTrack) {
      progressTrack.addEventListener('click', function (e) {
        if (!player || typeof player.getDuration !== 'function') return;
        var rect     = this.getBoundingClientRect();
        var pct      = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        var duration = player.getDuration();
        if (duration > 0) {
          player.seekTo(pct * duration, true);
          if (progressFill) progressFill.style.width = (pct * 100) + '%';
        }
      });
    }
  }

  /* ── Lancer l'init sur toutes les sections présentes ── */
  document.querySelectorAll('.caoine').forEach(function (root) {
    if (window._caoineYTReady) {
      initSection(root);
    } else {
      window._caoineQueue.push(function () { initSection(root); });
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
